import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

/**
 * Paso 2 del wizard: confirmación de que las Declaraciones Juradas de este
 * año ya están preparadas. Las DJJ y los movimientos de compras/ventas y
 * demás gastos alimentan la Declaración de Renta, así que conviene tenerlas
 * listas antes de calcular.
 *
 * Es solo una confirmación del usuario, no se valida contra la base de
 * datos: hay empresas que no deben presentar ninguna DJJ y otras que deben
 * presentar varias, así que no hay una regla genérica que verificar acá —
 * se delega la responsabilidad al usuario.
 */
const DJJGateStep = ({ anioTributario, onConfirmar, onFaltaPreparar }) => (
  <div className="djj-gate">
    <FaExclamationTriangle className="djj-gate-icon" />
    <p className="djj-gate-texto">
      Antes de calcular la Declaración de Renta AT {anioTributario}, asegúrate de haber
      preparado las Declaraciones Juradas de este año: ellas, junto con los
      movimientos de compras, ventas y demás gastos, alimentan el cálculo de
      la renta.
    </p>
    <div className="djj-gate-buttons">
      <button className="djj-gate-btn djj-gate-btn-si" onClick={onConfirmar}>
        Sí, ya preparé las declaraciones juradas
      </button>
      <button className="djj-gate-btn djj-gate-btn-no" onClick={onFaltaPreparar}>
        No, me falta preparar las declaraciones juradas
      </button>
    </div>
  </div>
);

export default DJJGateStep;
